let userIsActive = true;
let idleTimeout = null;

const IDLE_TIMEOUT_MINUTES = parseInt(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES || '8', 10);
const IDLE_LOGOUT_LIMIT = IDLE_TIMEOUT_MINUTES * 60 * 1000;
let logoutFn = null;

export const startUserActivityTracker = (onIdleLogout) => {
  logoutFn = onIdleLogout;

  const resetTimer = () => {
    userIsActive = true;

    if (idleTimeout) clearTimeout(idleTimeout);

    idleTimeout = setTimeout(() => {
      userIsActive = false; 
      logoutFn();           
    }, IDLE_LOGOUT_LIMIT);
  };

  const activityEvents = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];
  activityEvents.forEach(event => window.addEventListener(event, resetTimer));

  resetTimer(); 
};

export const isUserActive = () => userIsActive;
